import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { Grid, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { FormProvider, RHFTextField } from 'src/components/hook-form';
import useAppInfoStore from 'src/store/appInfo';
import { GeneralSelectMenu } from 'src/components/general';
import { generateSelectMenuItems } from 'src/utils';
import { useLocalStorage } from 'src/hooks/useLocalStorage';

export default function ContentSelectionTableToolbar({ onChangePage, setFilterItems }) {
  const [gameListFilters, setGameListFilters] = useLocalStorage('gameListFilters');

  const [gategories, setCategories] = useState([{ title: 'همه', id: -1 }]);
  const [selectedCategory, setSelectedCategory] = useState('');

  const { appInfo } = useAppInfoStore();

  // ----------------------------------------------------------------------

  const defaultValues = {
    ...gameListFilters,
  };

  const methods = useForm({
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (values) => {
    const PAYLOAD = {
      Title: values?.Title || '',
      CategoryID: selectedCategory,
      GameID: 0,
      IsLunchGame: 0,
    };

    setGameListFilters(PAYLOAD);

    setFilterItems(PAYLOAD);
    onChangePage(null, 0);
  };

  useEffect(() => {
    if (appInfo) {
      const categoryList = generateSelectMenuItems(appInfo?.CategoryGame, 'GameCategoryLable', 'GameCategoryID');
      setCategories([...gategories, ...categoryList]);
      setSelectedCategory(gameListFilters?.CategoryID || -1);
    }
  }, [appInfo]);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: 'grid',
              columnGap: 2,
              rowGap: 3,
              gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(3, 1fr)' },
            }}
          >
            <RHFTextField name="Title" type="text" label="جستجوی عنوان بازی" />

            <GeneralSelectMenu
              label="ژانر"
              name="CategoryID"
              options={gategories}
              value={selectedCategory}
              onChangeValue={setSelectedCategory}
            />

            <LoadingButton size="medium" type="submit" variant="contained" loading={isSubmitting} sx={{ height: '55px' }}>
              جستجو
            </LoadingButton>
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
